import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OrderCard from './OrderCard';
import SkeletonMyOrders from '../../Components/Molecules/Skeleton/SkeletonCategoryBar/SkeletonMyOrders';
import useData from './data';
import ZeroOrders from './ZeroOrders';
import DealSection from '../DealsAndDiscounts/Components/DealSection';
import useBookingSummary from '../../Hooks/use-bookingSummary';
import { loadMoreSvg } from '../DealsAndDiscounts/Components/ProductListing/svg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

const MyOrders = () => {
    const history = useHistory();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const [orderStatus, setOrderStatus] = useState('All');
    const [showOrderStatus, setShowOrderStatus] = useState(true);
    const [expandedOrderId, setExpandedOrderId] = useState(null); // Track the expanded order ID
    const changeStatus = (e) => {
        setOrderStatus(e.target.id);
    };
    const { orders, loadingOrders, deals } = useData(orderStatus);
    const { userAccountSummary } = useBookingSummary();

    const toggleExpanded = (orderId) => {
        setExpandedOrderId((prev) => (prev === orderId ? null : orderId)); // Toggle expanded order
    };

    useEffect(() => {
        if (orders?.length === 0 && !loadingOrders && orderStatus === 'All') {
            setShowOrderStatus(false);
        } else {
            setShowOrderStatus(true);
        }
    }, [orders, loadingOrders, orderStatus]);

    return (
        <div>
            {isAuthenticated && (
                <div className="w-full md:pl-3 lg:pl-7 2xl:pl-7 ">
                    <div className="">
                        <h1 className=" font-Poppins text-xl md:text-2xl font-bold">
                            My Orders
                        </h1>
                        <h3 className=" font-Poppins pt-1 text-sm md:text-sm">
                            Manage your Orders and Reward Points
                        </h3>
                    </div>

                    {showOrderStatus && (
                        <div className="flex gap-x-2 md:gap-x-6 items-center mt-4">
                            {[
                                'All',
                                'Order Placed',
                                'Shipped',
                                'Delivered'
                            ].map((status) => (
                                <div
                                    key={status}
                                    onClick={changeStatus}
                                    className={`cursor-pointer rounded-full px-4 py-2 text-[12px] md:text-[20px] lg:text-sm ${
                                        orderStatus === status
                                            ? 'text-white bg-primary'
                                            : 'text-black bg-gray-200'
                                    }`}
                                >
                                    <h3 id={status}>{status}</h3>
                                </div>
                            ))}
                        </div>
                    )}

                    {orders?.length == 0 && !loadingOrders && (
                        <div className="mt-8">
                            <ZeroOrders
                                orderStatus={orderStatus}
                                orders={orders}
                                loadingOrders={loadingOrders}
                            />
                        </div>
                    )}

                    <div className="py-6">
                        {loadingOrders && (
                            <>
                                <div className="mb-6">
                                    {[...Array(1).keys()].map((n) => (
                                        <SkeletonMyOrders key={n} />
                                    ))}
                                </div>
                                <div className="mt-4 mb-6">
                                    {[...Array(1).keys()].map((n) => (
                                        <SkeletonMyOrders key={n} />
                                    ))}
                                </div>
                            </>
                        )}

                        {!loadingOrders &&
                            orders?.map((order, index) => (
                                <OrderCard
                                    key={index}
                                    order={order}
                                    isExpanded={expandedOrderId === order.id} // Pass the expanded state
                                    toggleExpanded={() =>
                                        toggleExpanded(order.id)
                                    }
                                />
                            ))}
                        {userAccountSummary?.unInvoicedCommission > 0 && (
                            <div className="py-5">
                                <p className="mb-4 text-xl text-primary font-semibold">
                                    You have more rewards to redeem
                                </p>
                                {deals.length > 0 && (
                                    <DealSection
                                        type={' '}
                                        offers={deals.slice(0, 3)}
                                        isRewards={true}
                                        // className="mt-16"
                                    />
                                )}
                                <button
                                    onClick={() => history.push('/rewardStore')}
                                    className="flex items-center justify-center gap-x-2 mx-auto px-4 py-2 text-[#908F95] border-[3px] border-[#DDDDDD] rounded mb-6 mt-8"
                                >
                                    View More Rewards
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyOrders;
